import { z } from 'zod'

export const RClaimDiagnosisCodeMap = z.object({
	DiagnosisCode: z.string(),
	DiagnosisName: z.string(),
})
export type ClaimDiagnosisCodeMap = z.infer<typeof RClaimDiagnosisCodeMap>
